module.exports = __webpack_public_path__ + "img/ccl_gallery11.ed475d05.jpg";